import Select from 'react-select'

import { SelectData, SelectOption, SelectOptionString } from './models'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'
import { useEffect, useState } from 'react'
import { getPaymentMethods } from '../../modules/settings/api/getPaymentMethods'

export const selectType = 'paymentMethodType'

const PaymentMethodsFilter = ({
  changeSelect,
  isMultiple,
  value,
}: {
  changeSelect: (selectData: SelectData) => void
  isMultiple?: boolean
  value: string[]
}) => {
  const { mode: theme } = useThemeMode()
  const [options, setOptions] = useState<Array<SelectOption>>([])
  const [loading, setLoading] = useState(true)

  const updateListPaymentMethods = async () => {
    let response = await getPaymentMethods()

    if (response.data.success && response.data.paymentMethods) {
      let paymentMethods: Array<SelectOption> = []

      response.data.paymentMethods.forEach((value: any) => {
        const item = {
          value: value.type,
          label: value.type,
        }

        paymentMethods.push(item)
      })

      setOptions(paymentMethods)
      setLoading(false)
    }
  }

  useEffect(() => {
    updateListPaymentMethods()
  }, [])

  const handleChange = (selectedData: any) => {
    const values = !selectedData
      ? []
      : !isMultiple
      ? [selectedData.value]
      : selectedData.map((item: SelectOptionString) => item.value)

    changeSelect({
      value: values,
      type: selectType,
    })
  }

  return loading ? (
    <>Загрузка платежных методов...</>
  ) : (
    <Select
      value={options.filter((o: SelectOption) => value?.find((sv: any) => sv === o.value)) || ''}
      onChange={handleChange}
      isClearable={options.some((v) => !v.isFixed)}
      isMulti={isMultiple}
      options={options}
      placeholder={'Выберите платежный метод'}
      styles={SelectStyles(theme)}
    />
  )
}

export default PaymentMethodsFilter
